import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useUserType } from "../hooks/useUserType";

/**
 * Route guard: redirects D2C users away from clinic-only surfaces
 * (Communication, Share) to home. Renders children for everyone else.
 */
export function BlockD2C({ children }: { children: ReactNode }) {
	const { isD2C } = useUserType();
	if (isD2C) {
		return <Navigate to="/" replace />;
	}
	return <>{children}</>;
}
